<template>
	<div class="myWishlist">
		
		<b-container fluid class="p-0 mt-2">
			<b-row class="breadcrumbrow mt-1 m-0" v-if="products.length>0">
			<b-col>
			<h5 class="text-center">My Wishlist <span style="color:#b44ff3;font-size: 18px;">({{products.length}})</span> </h5>
			</b-col>
			<!--<b-col cols="6">
			</b-col>-->
			</b-row>
			<b-card >
			<b-row class="mb-3 mt-3">
				
				<b-col cols="12" lg="12" md="12" sm="12" class="" id="infinite-list" >
					 <transition name="fade">
					  <div class="loading" v-if="showPreloader">
						<span class="fa fa-spinner fa-spin"></span>
					  </div>
					</transition>
				  
					<div class="all-products--wrapper d-flex flex-wrap justify-content-between" v-if="products.length>0" >
					  <div v-for="product in products" :key="product.id"
						class="product--wrapper d-flex flex-column align-items-center">
						<!--<span class="product-title d-block"><a :href="'/product/'+product.product_id">{{product.title}}</a></span> -->
							<div class="deleteicon"><b-link @click="deleteWishlist(product.product_id)"><b-icon icon="x-circle" aria-hidden="true" class="deleteBtn"></b-icon></b-link> </div>
						<!--<product-offer :offer="true" :product="product"></product-offer> -->
						
						
						<div class="product--img-wrapper">
						<a v-if="product.product_slug==null" :href="'/product/'+product.product_id">
						  <b-img-lazy  v-bind="thumbnailProps" blank-color="#f7f7f7" 
							:src="$root.MEDIAAPI+'toolimage/get_image?size='+phoneImageWidth+'x'+phoneImageHeight+'&src='+product.image"
							:alt="product.title"></b-img-lazy>
						  </a>
						  <a v-else :href="'/'+product.product_slug">
						  <b-img-lazy  v-bind="thumbnailProps" blank-color="#f7f7f7" 
							:src="$root.MEDIAAPI+'toolimage/get_image?size='+phoneImageWidth+'x'+phoneImageHeight+'&src='+product.image"
							:alt="product.title"></b-img-lazy>
						  </a>
						  
						</div>
						<!--<product-offer-20 :offer="true" :product="product"></product-offer-20>-->
						
						<cateoryimage-slider v-if="product.product_slug==null"   :galleryimages="JSON.parse(product.gallery_images)" :phoneImageWidth="phoneImageWidth" :phoneImageHeight="phoneImageHeight" :product_slug="'/product/'+product.product_id" class="d-none d-md-block" ></cateoryimage-slider>
					<cateoryimage-slider v-else :galleryimages="JSON.parse(product.gallery_images)" :phoneImageWidth="phoneImageWidth" :phoneImageHeight="phoneImageHeight" :product_slug="'/'+product.product_slug" class="d-none d-md-block" ></cateoryimage-slider> 
					
					
					
					<addtocart-button :productData="product" :pagecategory="true" class="d-none d-md-block"></addtocart-button>
						
					   <b-link v-if="product.product_slug==null" :href="'/product/'+product.product_id" class="product-title text-capitalize">{{product.title}}</b-link>
					   <b-link v-else :href="'/'+product.product_slug" class="product-title text-capitalize">{{product.title}}</b-link>
						<product-price :category="true" :product="product"></product-price>
						<product-rating :userrating="product.total_rating"></product-rating>
						<product-commision :category="true" :product="product" :myroleId="myroleId"></product-commision>
						
						
						
						<addtocart-button :productData="product" :pagecategory="true" class="d-md-none"></addtocart-button> 
					   
					  </div>
					  
					  <div v-if="products.length%4>0" data-v-eedc78cc="" class=" d-flex flex-column align-items-center" style="width: 255px;"> 
						</div>
						
						 <div v-if="products.length%3>0" data-v-eedc78cc="" class=" d-flex flex-column align-items-center" style="width: 255px;"> 
						</div>
						
						
						
						
						
						
					</div>
					 
					  <div v-if="products.length==0" style="width: 100%;margin-top:12%">
						<div class="d-flex flex-column align-items-center" >
							<span class="product-title d-block">NO ITEMS IN THE WISHLIST</span>
							<p>Add now, Buy Later.</p>
							<p>
								 <b-button variant="outline" href="/" style="color: #b44ff3;border-color: #b856f5;">Start Shopping</b-button>
							</p>
						</div>
					  </div>
					 
					  
					 
					<!--<b-button type="button" pill class="btn--load-more" v-if="nextPage" @click="loadMore()">Load More</b-button>-->
				  </b-col>

			</b-row>
			
			
			</b-card>
		</b-container>
		
		
		
		<!-- <quickview :modaldata="$root.quickview_data"></quickview> -->
	</div>
</template>
<script>

import ProductRating from "@/components/product-rating.vue";
import ProductPrice from "@/components/product-price.vue";
import ProductCommision from "@/components/product-commision.vue";
//import ProductOffer from "@/components/product-offer.vue";
//import ProductOffer20 from "@/components/product-offer-20.vue";
import AddtocartButton from "@/components/addtocartButton.vue";
import CateoryimageSlider from "@/components/cateoryimageSlider.vue";
import '../assets/category.scss';
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
		"product-rating": ProductRating,
    "product-price": ProductPrice,
    "product-commision": ProductCommision,
    //"product-offer": ProductOffer,
    //"product-offer-20": ProductOffer20,
    "addtocart-button": AddtocartButton,
	"cateoryimage-slider": CateoryimageSlider,

	//props: ["time"],
	//template: '<div class="col-sm">  <div class="card text-center">    <div class="card-block">      <h4 class="card-title">{{time.time}}</h4>    </div>    <div class="card-footer">      {{time.text}}    </div>  </div></div>'

       
	},
	created:{
    
  },
	mounted(){
        this.initload();
		//var userRoll = this.$root.customer_info.role;
		
		
		//this.updateTimer();
		//this.timeinterval = setInterval(this.updateTimer, 1000);
	},
	data() {
		return{
			statusSidebar: false,
			products:[],
			thumbnailProps: { blank: false, fluidGrow: true, width: 350, height: 350,class: 'm1' },
			phoneImageWidth:350,
			phoneImageHeight:350,
            modal_data: {
                price: 0,
                special_price: 0
			},
			slide:0,
			historyPreUrl:'',
			walletRecord: [],
			blance: 0,
			cr_amount: 0,
			dr_amount: 0,
			crdate: '',
			expiresdate:'',
			cr_amount_cb:0,
			dr_amount_cb:0,
			blance_cb:0,
			total_blance:0,
			//url: this.$root.WEBURL+'customer-orders',
			recordUrl: this.$root.WEBURL+'mywishlist',
			deleteUrl: this.$root.WEBURL+'deleteWishlist',
			startTime: '', //"July 7, 2017 12:03:00",
			endTime: '', //"July 26, 2021 14:55:00",
			times: [
			  { id: 0, text: "Days", time: 1 },
			  { id: 1, text: "Hours", time: 1 },
			  { id: 2, text: "Minutes", time: 1 },
			  { id: 3, text: "Seconds", time: 1 }
			],
			progress: 100,
			// isActive: false,
			timeinterval: undefined,
		};
	},
	methods: {
		burgerMenuSidebar() {
		  this.statusSidebar = !this.statusSidebar;
		},
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.recordUrl, {
                accesskey: self.$session.get('access_key'),
                roleId: self.$root.customer_info.role,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.products 	= response.data.result.products;
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		deleteWishlist(proId){
			var self = this;
			self.axios.post(self.deleteUrl, {
                accesskey: self.$session.get('access_key'),
                pId: proId,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    //self.products 	= response.data.result.products;
					
					self.$bvToast.toast(response.data.message, {
							title: `Wishlist Remove`,
							variant: 'success',
							toaster: 'b-toaster-bottom-right',
							solid: true,
							appendToast: true ,
							noAutoHide: true
						  }) 
					self.initload();
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}else{
					self.$bvToast.toast(response.data.message, {
							title: `Wishlist`,
							variant: 'warning',
							toaster: 'b-toaster-bottom-right',
							solid: true,
							appendToast: true,
							noAutoHide: true
						  })
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		popoverMethod(){
			 return '<ul class="p-0"><li>• 100% cashback applicable on cash orders only</li><li>• Cashback credited immediately but can be used after order is delivered & there is no return</li><li>•	Only 50% can be redeemed at one time</li></ul>';
		},
		
	}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   lang="scss">

.myWishlist{
	.deleteicon{
    position: absolute;
    margin-right: -21%;
    margin-top: -9px;
}
.deleteBtn{
color: #b856f5;
}

 btn--product-add-to-favourites-heart-fill{
	display:none;
	}
	.addtofavouritebtn{
		display: none;
	}

}



</style>